import type {TemplateTypeValue} from './types';

/** Human label for a template type — the tab it lives under. */
export const TEMPLATE_TYPE_LABEL: Record<TemplateTypeValue, string> = {
  photo_report: 'Photo Report',
  jac: 'JAC',
};

/**
 * The type a template would migrate to (DERP-254).
 *
 * There are exactly two, so a template only ever has one place to go — the
 * migrate action needs no target picker, and the direction is implied by the tab
 * the template is currently on.
 *
 * Lives here rather than beside the dialog so the list row and the dialog agree
 * on the direction and its wording, and so neither file exports a non-component
 * (which breaks Fast Refresh).
 */
export function otherType(t: TemplateTypeValue): TemplateTypeValue {
  return t === 'photo_report' ? 'jac' : 'photo_report';
}
